// Pages/users/OrderDetails.jsx
import React, { useEffect, useState } from "react";
import {
  Typography,
  Card,
  Divider,
  Row,
  Col,
  Tag,
  Image,
  Modal,
  Input,
  Button,
  message,
} from "antd";
import { useParams } from "react-router-dom";
import axios from "axios";
import logo from "../../Assets/logo.gif";
import SummaryApi from "../../common/index";

const { Title, Text } = Typography;

const statusColors = {
  paid: "green",
  pending: "orange",
  failed: "red",
  cancelled: "volcano",
  completed: "green",
  ready_for_pickup: "blue",
};

const statusMessages = {
  pending: "Your payment is still pending. Please complete it to confirm your order.",
  paid: "Your payment is successful. Waiting for seller confirmation.",
  ready_for_pickup:
    "Your order is confirmed and ready for pickup at our store. You can come at your convenience to collect it.",
  completed: "Order completed. Thank you for shopping with us!",
  cancelled: "Your order has been cancelled.",
  returned: "Your order has been returned. Please Visit Our Store To Return The Product Within The Seven Days Of the Order Pickup From Our Store.",
  return_requested:
    "We’re sorry for the inconvenience. Please visit the store to return the product within 7 days.",
  pay_at_store:
    "Your order is confirmed. Please wait for the seller’s confirmation to prepare your order for pickup.",
};


const OrderDetails = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [returning, setReturning] = useState(false);
const [showReturnModal, setShowReturnModal] = useState(false);
  const defaultImage = "/images/default.jpg";

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;

  const handleReturnOrder = async () => {
  try {
    setReturning(true);
    const token = localStorage.getItem("token");
    const res = await axios.put(
      SummaryApi.returnRequest(order.id).url,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      }
    );

    if (res.data.success) {
      message.success("Return request submitted successfully.");
      setOrder({ ...order, status: "Returned" });
      setShowReturnModal(false);
    } else {
      message.warning(res.data.message || "Unable to submit return request.");
    }
  } catch (err) {
    console.error(err);
    message.error("Something went wrong. Try again.");
  } finally {
    setReturning(false);
  }
};
  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const token = localStorage.getItem("token");
        const { data } = await axios.get(
          SummaryApi.getOrderDetails(orderId).url,
          {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true,
          }
        );
        if (data.success) {
          setOrder(data.order);
          console.log("ORDER DATA =>", data.order);
          console.log("ORDER RAW STATUS:", data.order.status);
console.log("PAYMENT METHOD:", data.order.payment_method);
console.log("PAID AT:", data.order.paid_at);


        } else {
          message.error("Failed to fetch order details");
        }
      } catch (err) {
        console.error(err);
        message.error("Something went wrong while fetching order details");
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [orderId]);

  // Handle cancel order
  const handleCancelOrder = async () => {
    if (!cancelReason.trim()) {
      return message.warning("Please provide a reason for cancellation");
    }

    try {
      setSubmitting(true);
      const token = localStorage.getItem("token");
      const res = await axios.put(
        SummaryApi.cancelOrder(order.id).url,
        { reason: cancelReason },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.status === 200 && res.data.success === true) {
        // ✅ Close modal immediately
        setShowCancelModal(false);
        setCancelReason("");

        // ✅ Update order state instantly
        setOrder({
          ...order,
          status: "cancelled",
          cancel_reason: cancelReason,
          cancelled_at: new Date().toISOString(),
        });

        // ✅ Show green success message
        message.success({
          content: " Order cancelled successfully",
          duration: 3,
        });
      } else {
        // ⚠️ Backend validation warning
        message.warning({
          content: res.data.message || "⚠️ Unable to cancel order",
          duration: 3,
        });
      }
    } catch (err) {
      // ❌ Network/server errors
      const errMsg =
        err.response?.data?.message || "❌ Something went wrong, try again";
      message.error({ content: errMsg, duration: 3 });
    } finally {
      setSubmitting(false);
    }
  };

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <img src={logo} alt="Loading..." style={{ width: 150, height: 150 }} />
      </div>
    );

  if (!order)
    return (
      <Text
        style={{ display: "block", textAlign: "center", marginTop: "60px" }}
      >
        Order not found.
      </Text>
    );

  // Can cancel: within 7 days & not cancelled/completed
  const orderDate = new Date(order.created_at);
  const today = new Date();
  const diffDays = Math.floor((today - orderDate) / (1000 * 60 * 60 * 24));
  const canCancel =
    diffDays <= 7 && !["cancelled", "completed"].includes(order.status);

  return (
    <div style={{ padding: "20px", maxWidth: 900, margin: "0 auto" }}>
      <Title level={3} style={{ marginBottom: 20, textAlign: "center" }}>
        Order Details
      </Title>

      <Card
        style={{
          marginBottom: 20,
          borderRadius: 10,
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Row justify="space-between" align="middle">
          <Col>
            <Text strong>{order.order_number || order.id}</Text>
          </Col>
          <Col>
            <Tag color={statusColors[order.status] || "blue"}>
            {order.status.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}

            </Tag>
          </Col>
        </Row>
<Text
  style={{
    display: "block",
    marginTop: 8,
    fontStyle: "Times New Roman",
    color: "Blue",
    fontWeight: "bold",
  }}
>
  {order.payment_method === "pay_at_store"
    ? statusMessages.pay_at_store
    : statusMessages[order.status] || ""}
</Text>



        <Text type="secondary">
          Ordered on: {new Date(order.created_at).toLocaleString()}
        </Text>

        {order.status === "cancelled" && (
          <div style={{ marginTop: 10 }}>
            <Text type="danger">
              Cancelled on:{" "}
              {order.cancelled_at
                ? new Date(order.cancelled_at).toLocaleString()
                : "N/A"}
            </Text>
            <br />
            <Text type="secondary">
              Reason: {order.cancel_reason || "Not provided"}
            </Text>
          </div>
        )}

        <Divider />
        <Title level={5}>Store Details</Title>
        {order.seller ? (
          <>
            <Text strong>{order.seller.store_name}</Text>
            <br />
            <Text>{order.seller.phone}</Text>
            <br />
            <Text>{order.seller.fullAddress}</Text>
          </>
        ) : (
          <Text type="secondary">No seller info available</Text>
        )}

        <Divider />
        <Title level={5}>Payment Details</Title>
  <Text strong>Payment Method:</Text> {order.payment_method}
<br />

{order.payment_method === "pay_at_store" ? (
  order.status === "completed" ? (
    
    <Text style={{ color: "#4CAF50", fontWeight: "bold" }}>
      Payment Done (Paid at Store)
    </Text>
  ) : order.status === "cancelled" ? (
    <Text style={{ color: "red", fontWeight: "bold" }}>
      Payment Cancelled
    </Text>
  ) : (
    <Text style={{ color: "orange", fontWeight: "bold" }}>
      Payment Pending (Pay at Store)
    </Text>
  )
) : order.paid_at ? (
  <Text>Paid on: {new Date(order.paid_at).toLocaleString()}</Text>
) : (
  <Text type="warning">Payment pending</Text>
)}
<br />
        {order.razorpay_payment_id && (
          <>
            <br />
            <Text>Razorpay Payment ID: {order.razorpay_payment_id}</Text>
          </>
        )}
      </Card>

      {/* Products */}
      <Title level={4} style={{ marginBottom: 10 }}>
        Products
      </Title>
      {order.items.map((item) => {
        const productImage =
          Array.isArray(item.product.images) && item.product.images.length > 0
            ? `${BASE_URL}${encodeURI(item.product.images[0])}`
            : "/placeholder.png";

        return (
          <Card
            key={item.id}
            style={{
              marginBottom: 15,
              borderRadius: 10,
              boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
            }}
            hoverable
          >
            <Row gutter={16} align="middle">
              <Col>
                <Image
                  src={productImage}
                  alt={item.product.name}
                  width={80}
                  height={80}
                  style={{ objectFit: "cover", borderRadius: 8 }}
                  fallback="/placeholder.png"
                   onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = defaultImage;
                        }}
                />
              </Col>
              <Col flex="auto">
                <Text strong>{item.product.name}</Text>
                <br />
                <Text type="secondary">
                  Qty: {item.quantity} × ₹{item.product.price}
                </Text>
              </Col>
              <Col>
                <Text strong>₹{item.quantity * item.product.price}</Text>
              </Col>
            </Row>
          </Card>
        );
      })}

      <Divider />
      <Title level={4} style={{ textAlign: "right" }}>
        Total Amount: ₹{order.amount}
      </Title>

      {/* Cancel Order Button */}
  {canCancel && order.status !== "returned" && order.status !== "return_requested" && (
  <div style={{ textAlign: "center", marginTop: 20 }}>
    <Button
      danger
      onClick={() => setShowCancelModal(true)}
      loading={submitting}
    >
      Cancel Order
    </Button>
  </div>
)}


      {/* Cancel Reason Modal */}
      <Modal
        title="Cancel Order"
        open={showCancelModal}
        onOk={handleCancelOrder}
        onCancel={() => setShowCancelModal(false)}
        okText={submitting ? "Cancelling..." : "Confirm Cancel"}
        okButtonProps={{ disabled: submitting }}
      >
        <p>Please provide a reason for cancelling your order:</p>
        <Input.TextArea
          rows={3}
          value={cancelReason}
          onChange={(e) => setCancelReason(e.target.value)}
          placeholder="e.g., Found a better price, ordered by mistake..."
        />
      </Modal>
        {/* ✅ Return Order Button */}
{order.status === "completed" && diffDays <= 7 && (
  <div style={{ textAlign: "center", marginTop: 20 }}>
    <Button
      type="primary"
      danger
      onClick={() => setShowReturnModal(true)}
      loading={returning}
    >
      Return Product
    </Button>
  </div>
)}

{/* ✅ Return Confirmation Modal */}
<Modal
  title="Return Product"
  open={showReturnModal}
  onOk={handleReturnOrder}
  onCancel={() => setShowReturnModal(false)}
  okText={returning ? "Submitting..." : "Confirm Return"}
  okButtonProps={{ disabled: returning }}
>
  <p>
    We’re sorry for the inconvenience. Please confirm if you want to initiate a
    return for this order.
  </p>
  <p style={{ color: "red", marginTop: 10 }}>
    Note: You can return the product only within 7 days of completion.
  </p>
</Modal>




    </div>
  );
};

export default OrderDetails;
